import { TabProvider } from '../tabs';
import { Tab, TabPanel, TabList } from './TabsDefaultSkin.styles';

export default TabProvider;
export { TabProvider, Tab, TabPanel, TabList };
